/*
 * @Author: czj
 * @Date: 2025-01-13 10:40:51
 * @Description: 
 * @FilePath: \sanshu-report-new\src\main.js
 */
import { createApp } from 'vue'
import App from './App.vue';
import { createPinia } from 'pinia';

import './style/index.scss';

import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';


const observerErr = /ResizeObserver loop completed with undelivered notifications/;
window.addEventListener('error', (e) => {
  if (observerErr.test(e.message)) {
    e.stopImmediatePropagation();
  }
});
window.addEventListener('unhandledrejection', (e) => {
  if (observerErr.test(e.reason)) {
    e.stopImmediatePropagation();
  }
});


const pinia = createPinia();
// console.log = () => undefined;// 屏蔽控制台输出
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) { // 注册element-plus的icon
  app.component(key, component)
}
app.use(ElementPlus);
app.use(pinia);
app.mount('#app');